import React, { useContext, useEffect, useState } from 'react';
import { ModulesWrapper } from 'pages/resources/modules/Modules.styled';
import { Container, PageInnerTitle } from 'layout/page/Page.layout.styled';
import { useTranslation } from 'react-i18next';
// import useAPIResources from 'hooks/api/useAPIResources';
// import { IModules } from 'types/app';
import ModulesList from 'components/resources/module/moduleslist/ModulesList';
import { PayableToolsContext, PayableToolsContextProps } from 'contexts/PayableToolsContext';
import { UserContext, UserContextProps } from 'contexts/UserContext';
import { ModuleContext, ModuleContextProps } from 'contexts/ModuleContext';
import { useLocation } from 'react-router';
import useAPIResources from 'hooks/api/useAPIResources';
import { MODULES_CODES } from 'constants/global';
import { parseQueryString } from 'helpers/utils';

const Modules: React.FC<any> = () => {
  const { t } = useTranslation('translation');
  const { user } = useContext(UserContext) as UserContextProps;
  const { openElearningModule } = useAPIResources();
  const [isLoaded, setIsLoaded] = useState(false);
  const [defaultOpenedId, setDefaultOpenedId] = useState(-1);
  const location = useLocation();
  const { payableTools, loadPayableTools } = useContext(
    PayableToolsContext,
  ) as PayableToolsContextProps;

  const { loadModules, modules } = useContext(ModuleContext) as ModuleContextProps;

  useEffect(() => {
    if (user) {
      loadPayableTools();
    }
  }, []);

  useEffect(() => {
    if (!isLoaded && payableTools?.length >= 0) {
      loadModules();
      setIsLoaded(true);
    }
    // console.log(payableTools);
  }, [payableTools]);

  useEffect(() => {
    if (modules?.length > 0) {
      const queryString = location?.location?.search || location?.search || '';
      const qsObject = parseQueryString(queryString);

      // const qsModule = qs ? qs
      const activeModuleCode = qsObject?.module?.toLowerCase();
      if (activeModuleCode === MODULES_CODES.ELEARNING) {
        const id = modules.findIndex((module) => `${module.code}` === activeModuleCode);
        if (id > -1) {
          setDefaultOpenedId(id);
          setTimeout(() => openElearningModule(), 500);
        }
      }
    }
  }, [modules, location, user]);

  return (
    <ModulesWrapper>
      <Container className="app-page">
        <PageInnerTitle
          dangerouslySetInnerHTML={{
            __html: t('resources.modules.title'),
          }}
        />
      </Container>
      {modules && <ModulesList modules={modules} defaultOpenedId={defaultOpenedId} />}
    </ModulesWrapper>
  );
};
export default Modules;
